export default __webpack_public_path__ + "static/media/25.a399bd89.webp";